import { computed } from 'vue'
import { useLogger } from '@booksy-com/vue-tools'

import { useCore } from '@/composables/core/index.js'
import { ENDPOINTS } from '@/lib/consts.js'

const logger = useLogger('polls-composable')

export function usePolls () {
  const { apiCall, store } = useCore()
  const business = computed(() => store.state.business?.business)

  const loadPollsList = async (pollsGroupName) => {
    if (!business.value) {
      logger.error('loadPollsList called without business id')
      return
    }
    try {
      const response = await apiCall({
        method: 'POST',
        url: ENDPOINTS.POLLS_LIST,
        urlParams: {
          businessId: business.value.id,
        },
        data: {
          group_name: pollsGroupName,
        },
      })

      return response.data
    } catch (error) {
      logger.error(error)
      return null
    }
  }

  const savePoll = async ({ pollName, choices }) => {
    if (!business.value) {
      logger.error('savePoll called without business id')
      return
    }

    try {
      await apiCall({
        method: 'POST',
        url: ENDPOINTS.POLL,
        urlParams: {
          businessId: business.value.id,
        },
        data: {
          poll_name: pollName,
          choice_ids: choices,
        },
      })
      return Promise.resolve()
    } catch (error) {
      logger.error(error)
      return Promise.reject(error)
    }
  }

  return {
    loadPollsList,
    savePoll,
  }
}
